import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsLogOutIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M14.388.75c1.228.06 2.167 1.085 2.113 2.284l.001 4.466c0 .414-.335.75-.75.75-.414 0-.75-.336-.75-.75V3c.018-.403-.275-.732-.652-.751L2.115 2.25c-.34.018-.63.346-.614.716L1.502 21c-.018.403.275.732.651.751l12.235-.001c.341-.018.632-.346.615-.716V16.5c0-.414.335-.75.75-.75.414 0 .75.336.75.75V21c.053 1.173-.879 2.189-2.078 2.249l-12.31.001h-.019C.888 23.189-.052 22.165.003 20.966V3C-.054 1.828.877.811 2.077.751L14.388.75zm5.113 6.753c.2 0 .39.08.53.22l3.75 3.75c.035.035.067.073.094.114.007.01.015.025.022.038.017.028.032.057.045.087.007.016.016.045.021.061.068.202.044.424-.066.607-.031.056-.07.107-.116.153l-3.75 3.75c-.139.142-.33.222-.529.221-.302-.002-.574-.185-.69-.464-.116-.28-.053-.602.16-.817l2.47-2.47H7.502c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h13.94l-2.47-2.47c-.143-.141-.22-.33-.22-.53s.077-.389.22-.53c.14-.14.33-.22.53-.22z" transform="translate(-.003)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsLogOutIcon = __decorateClass([
  customElement("elm-actions-log-out-icon")
], ActionsLogOutIcon);
export { ActionsLogOutIcon };
